// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(true);
// Module
exports.push([module.id, ".row-date_6d20 {\n  white-space: nowrap;\n}", "",{"version":3,"sources":["/home/runner/work/telemetry/telemetry/ts/packages/frontend/src/component/Settings/RowDate.scss","RowDate.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;ACCJ","file":"RowDate.scss","sourcesContent":[".row-date {\n    white-space: nowrap;\n}\n",".row-date {\n  white-space: nowrap;\n}"]}]);
// Exports
exports.locals = {
	"row-date": "row-date_6d20"
};
module.exports = exports;
